
import axios from 'axios'
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { downloadFile } from '../../global/functions/util'
import ReportCard from '../components/ReportCard.vue'

@Component({
  components: { ReportCard }
})
export default class ReportingPage extends Vue {

  generateAccountingReport(data: any) {
    downloadFile(`${axios.defaults.baseURL}/transactions/report?fromDate=${data.from}&toDate=${data.to}`)
  }

  generateAgencyReport(data: any) {
    downloadFile(`${axios.defaults.baseURL}/reporting/agency-report?fromDate=${data.from}&toDate=${data.to}`)
  }
}
